import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { PRODUCT_IDS } from "utils/constants";
import { Toggle, MobileContext, Button } from "components/common";
import BankAccountItem from "./utils/BankAccountItem";

const NoAccountsMessage = ({ isMobile }) => {
  return (
    <div className={`${isMobile ? "text-center mt-5" : "my-4"}`}>
      <Button purple overrideStyle>
        <Link
          to={{ pathname: `/boost`, search: "?addAccount=true" }}
          className="text-white font-semibold hover:text-white hover:font-semibold"
        >
          Link your first account
        </Link>
      </Button>
    </div>
  );
};

const ManageTrackedAccountOpen = ({
  accounts,
  removeAccountTracking,
  addAccountTracking,
}) => {
  const { isMobile } = useContext(MobileContext);
  return (
    <div className="w-full">
      {accounts.length > 0 && (
        <div className="text-center">
          <p className="pt-2 text-xs text-gray-700">
            Toggle to extract/remove bills for TomoBoost.
          </p>
          <p className="text-xs text-gray-700 ">
            Additional bills help boost your credit.
          </p>
        </div>
      )}
      {accounts?.length > 0 ? (
        accounts.map((acc) => {
          const { appliedProducts, uuid } = acc;
          const isTracked = appliedProducts.includes(PRODUCT_IDS.CREDIT_BOOST);
          return (
            <div className="flex justify-between">
              <div style={{ ...(isMobile && { maxWidth: 250 }) }}>
                <BankAccountItem account={acc} />
              </div>
              <div className="py-5">
                <Toggle
                  active={isTracked}
                  value={uuid}
                  onChange={() => {
                    if (isTracked) {
                      removeAccountTracking([uuid]);
                    } else {
                      addAccountTracking([uuid]);
                    }
                  }}
                />
              </div>
            </div>
          );
        })
      ) : (
        <NoAccountsMessage isMobile={isMobile} />
      )}
    </div>
  );
};

export default ManageTrackedAccountOpen;
